<script>
import Loader from "@/components/widgets/loader";
/**
 * Profile component
 */
export default {
  components: {
    Loader,
  },
  data() {
    return {};
  },
  mounted() {},
  props: {
    updating: {
      type: Boolean,
    },
    profile: {
      type: Object,
      default: () => {
        return { 
          business_admin_image: null,
          business_logo: "",
          email: "",
          mobile: "",
          user_id: null 
        }
      },
    }
  },
};
</script>
<template>
  <Loader :loading="updating">
    <div class="card overflow-hidden">
      <div class="bg-soft bg-primary">
        <div class="row">
          <div class="col-7">
            <div class="text-primary p-3">
              <h5 class="text-primary mb-3">Welcome Back !</h5>
            </div>
          </div>
          <div class="col-5 align-self-end">
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-sm-4">
            <div class="avatar-md profile-user-wid mb-1">
              <img v-if="profile.business_logo"
                :src="$image_url + profile.business_logo"
                alt
                class="img-thumbnail rounded-circle"
              />
              <img v-else src="@/assets/images/no-image.png" alt="No Image" class="img-thumbnail rounded-circle" />
            </div>
            <!-- <h5 class="font-size-15 text-truncate">admin</h5> -->
            <div class="mt-3">
              <a href="/profile" class="btn btn-primary btn-sm">
                  Profile
                <i class="mdi mdi-arrow-right ms-1"></i>
              </a>
            </div>
          </div>

          <div class="col-sm-8">
            <div class="pt-4">
              <div class="row">
                <!-- <div class="col-6">
                  <h5 class="font-size-15">25</h5>
                  <p class="text-muted mb-0">Pending Leads</p>
                </div>
                <div class="col-6">
                  <h5 class="font-size-15">30</h5>
                  <p class="text-muted mb-0">Active Policies</p>
                </div> -->

                <div class="col-12">
                  <h6></h6>
                  <p>+91 {{profile.mobile}}<br>{{profile.email}}</p>

                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <!-- end card-body -->
    </div>
    <!-- end card -->
  </Loader>
</template>
